// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27M6 8l4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/images/ornament-7-1-min.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets//images//ornament-8-min.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield;
  /* 1 */
  outline-offset: -2px;
  /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button;
  /* 1 */
  font: inherit;
  /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1;
  /* 1 */
  color: #9ca3af;
  /* 2 */
}

/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block;
  /* 1 */
  vertical-align: middle;
  /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
  width: 100%;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

[type='text'],
[type='email'],
[type='url'],
[type='password'],
[type='number'],
[type='date'],
[type='datetime-local'],
[type='month'],
[type='search'],
[type='tel'],
[type='time'],
[type='week'],
[multiple],
textarea,
select {
  appearance: none;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  border-radius: 0px;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-shadow: 0 0 #0000;
}

[type='text']:focus,
[type='email']:focus,
[type='url']:focus,
[type='password']:focus,
[type='number']:focus,
[type='date']:focus,
[type='datetime-local']:focus,
[type='month']:focus,
[type='search']:focus,
[type='tel']:focus,
[type='time']:focus,
[type='week']:focus,
[multiple]:focus,
textarea:focus,
select:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,
      /*!*/
      /*!*/
    );
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-color: #2563eb;
}

input::placeholder,
textarea::placeholder {
  color: #6b7280;
  opacity: 1;
}

::-webkit-datetime-edit-fields-wrapper {
  padding: 0;
}

::-webkit-date-and-time-value {
  min-height: 1.5em;
}

select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
  padding-right: 2.5rem;
  -webkit-print-color-adjust: exact;
  color-adjust: exact;
}

[multiple] {
  background-image: initial;
  background-position: initial;
  background-repeat: unset;
  background-size: initial;
  padding-right: 0.75rem;
  -webkit-print-color-adjust: unset;
  color-adjust: unset;
}


[type='file'] {
  background: unset;
  border-color: inherit;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-size: unset;
  line-height: inherit;
}

[type='file']:focus {
  outline: 1px auto -webkit-focus-ring-color;
}

*,
::before,
::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x: ;
  --tw-pan-y: ;
  --tw-pinch-zoom: ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal: ;
  --tw-slashed-zero: ;
  --tw-numeric-figure: ;
  --tw-numeric-spacing: ;
  --tw-numeric-fraction: ;
  --tw-ring-inset: ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur: ;
  --tw-brightness: ;
  --tw-contrast: ;
  --tw-grayscale: ;
  --tw-hue-rotate: ;
  --tw-invert: ;
  --tw-saturate: ;
  --tw-sepia: ;
  --tw-drop-shadow: ;
  --tw-backdrop-blur: ;
  --tw-backdrop-brightness: ;
  --tw-backdrop-contrast: ;
  --tw-backdrop-grayscale: ;
  --tw-backdrop-hue-rotate: ;
  --tw-backdrop-invert: ;
  --tw-backdrop-opacity: ;
  --tw-backdrop-saturate: ;
  --tw-backdrop-sepia: ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x: ;
  --tw-pan-y: ;
  --tw-pinch-zoom: ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal: ;
  --tw-slashed-zero: ;
  --tw-numeric-figure: ;
  --tw-numeric-spacing: ;
  --tw-numeric-fraction: ;
  --tw-ring-inset: ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur: ;
  --tw-brightness: ;
  --tw-contrast: ;
  --tw-grayscale: ;
  --tw-hue-rotate: ;
  --tw-invert: ;
  --tw-saturate: ;
  --tw-sepia: ;
  --tw-drop-shadow: ;
  --tw-backdrop-blur: ;
  --tw-backdrop-brightness: ;
  --tw-backdrop-contrast: ;
  --tw-backdrop-grayscale: ;
  --tw-backdrop-hue-rotate: ;
  --tw-backdrop-invert: ;
  --tw-backdrop-opacity: ;
  --tw-backdrop-saturate: ;
  --tw-backdrop-sepia: ;
}

.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 1rem;
  padding-left: 1rem;
}

@media (min-width: 576px) {
  .container {
    max-width: 576px;
    padding-right: 2rem;
    padding-left: 2rem;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 768px;
  }
}

@media (min-width: 992px) {
  .container {
    max-width: 992px;
    padding-right: 4rem;
    padding-left: 4rem;
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 1200px;
    padding-right: 5rem;
    padding-left: 5rem;
  }
}

@media (min-width: 1400px) {
  .container {
    max-width: 1400px;
    padding-right: 9rem;
    padding-left: 9rem;
  }
}



.btn {
  display: inline-block;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  border-radius: 0.25rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  outline: 2px solid transparent;
  outline-offset: 2px;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 500ms;
}

.btn:hover {
  --tw-translate-y: -0.375rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.btn:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-offset-width: 0px;
}

.slideuphover {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 500ms;
}

.slideuphover:hover {
  --tw-translate-y: -0.375rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.dropdown {
  position: relative;
}

.dropdown-menu {
  position: static;
  z-index: 20;
  display: none;
  text-align: left;
  width: 14rem;
  /*   
  border-radius: 0.25rem; */
  background-color: transparent;

  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.navbar-custom .navbar-nav .nav-item {
  color: #fff;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 1.5;
  word-spacing: 1.5;
}

.navbar-custom .navbar-nav .nav-item:hover {
  color: #FF7800;
}

.Get-button {
  font-size: 18px;
  font-weight: 500;
  line-height: 1em;
  color: #FFFFFF;
  background-color: #1C6EEE00;
  border: 3px solid;
  border-radius: 3px;
  padding: 14px 20px 14px 20px;
}

.elementor-animation-float {
  transition-duration: .3s;
  transition-property: transform;
  transition-timing-function: ease-out;
}

.elementor-animation-float:hover {
  transform: translateY(-8px);
}

.Heading-01 {

  color: white;
  font-size: 66px;
  font-weight: 600;
  line-height: 1.3em;


}

.Heading-02 {
  color: #0b1622;
  font-size: 52px;
  font-weight: 600;
  line-height: 1.2em;


}

.heading-title {
  color: #ffffff;
  font-size: 40px;
  font-weight: 600;
  line-height: 1.3em;
 
}

.heading-para {
  color: #b3b5b9;
  font-size: 14px;
  font-weight: 400;
  line-height: 2.05em;
  /* letter-spacing: 0.1rem; */
}

.sub-titles {
  color: #0b1622;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.2em;
  
}

.paragraph {
  font-size: 16px;
  color: #737e8c;


}

.bbt {
  border-radius: 6px;
  height: 54px;
}

.bbt:hover {
  border-radius: 6px;
  height: 54px;
}

.fearure-head {
  font-size: 22px;
  font-weight: 600;
  color: #0b1622;
}

.fearure-head2 {
  font-size: 22px;
  font-weight: 200;
  color: #0b1622;
}

.feature-para {
  font-size: 15px;
  font-weight: 500;
  color: #737e8c;
}

.elementor-icon-list-item {
  display: flex;
  align-items: center;
}

.elementor-icon-list-text {
  font-weight: 600;
  font-size: 20px;
  color: #0b1622;
  letter-spacing: 0.03rem;
}

h6.elementor-heading-title {
  font-weight: 600;
  font-size: 18px;
  letter-spacing: 0.03rem;
  color: #0b1622;
}

.elementor-motion-effects-layer {
  background-color: #1c55ab;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: top left;
  background-repeat: no-repeat;
}

.react-player__preview {
  border-radius: 10px;
}

.react-player__preview button {
  font-size: 135px;
  color: #ffffffb5;
}

h5.misium-head {
  font-size: 25px;
  font-weight: 600;
  letter-spacing: 0.02rem;
  color: #0b1622;
  line-height: 1.9rem;
}
#flip {
  height: 61px;
  overflow: hidden;
  position: absolute;
  left: 0s;
  top: auto !important;
}

#flip>div>div {
  color: #fff;
  padding: 13px 12px;
  height: 59px;
  margin-bottom: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
}


/* #flip div:nth-child(2) {
  animation: show 8s linear infinite;
} */

#flip div:first-child {
  animation: show 5s linear infinite;
}

.available-app-area {
  position: relative;
  padding-top: 100px;
  padding-bottom: 100px;
  background-image: linear-gradient(90deg, #095bc1 33%, #00d4ff 100%);
  background-image: -ms-linear-gradient(90deg, #095bc1 33%, #00d4ff 100%);
}

.available-app-area .app-caption .section-tittle3 h2 {
  color: #fff;
  margin-bottom: 8px;
  font-weight: 600;
}
.section-tittle h2 {
  font-size: 50px;
  font-weight: 700;
  line-height: 1.2;
 
}

@media (max-width: 991px) {
  .Reliable {
    position: relative;
    top: -6px;
    height: 68px !important;
}
.Secure {
  position: relative;
  top: -9px;
}

  .simple {
    position: relative;
    top: -4px;
}

  /* #flip {
    top: 26px;

  } */

}

#flip div div {
  color: #42c58a;
}

#flip div:first-child div {
  color: #4ec7f3;
}

#flip div:last-child div {
  color: #eabb76;
}

ul.mobile-link li:hover {
  color: #fd7701;
}

@keyframes show {
  0% {
    margin-top: -270px;
  }

  5% {
    margin-top: -180px;
  }

  33% {
    margin-top: -180px;
  }

  38% {
    margin-top: -90px;
  }

  66% {
    margin-top: -90px;
  }

  71% {
    margin-top: 0px;
  }

  99.99% {
    margin-top: 0px;
  }

  100% {
    margin-top: -270px;
  }
}


@media (min-width: 992px) {
  .dropdown-menu {
    position: absolute;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}

.dropdown-menu {
  animation-name: DropDownSlide;
  animation-duration: 0.4s;
  animation-fill-mode: both;
}

@keyframes DropDownSlide {
  100% {
    opacity: 1;
    transform: translateY(0);
  }

  0% {
    opacity: 0;
    transform: translateY(10px);
  }
}

/* .dropdown-menu.show{
  display: block;
} */

.dropdown-item {
  /* display: block; */
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-size: 1.0rem;
  line-height: 1.25rem;
  text-transform: capitalize;
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
  transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;


}

.dropdown-item:hover {
  background-color: transparent;
}

/* .dropdown-item:hover {
  animation-name: DropDownSlide;
  animation-duration: 0.4s;
  animation-fill-mode: both;
} */

.dropdown-menu li:hover {
  color: #fe7b05;
}

.small-head {
  color: #737e8c;
  margin: 0px 0px 20px 0px;
  padding: 2px 10px 2px 10px;
  background-color: #0d20360d;
  border-radius: 3px 3px 3px 3px;
  font-weight: 600;
  line-height: 0.1em;
  font-size: 12px;
}

.elementor-motion-effects-layer2 {
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-position: 155% -192px;
  background-repeat: no-repeat;
  /* background-size: contain; */

}

.menu-item li {
  color: #ffffff99;
  font-size: 14px;
}

.scrollToTop {
  background: #1c55ab;
  position: absolute;
  color: #fff;
}

.num {
  display: flex;
  align-items: center;
  font-size: 55px;
  font-weight: 700;
  color: #1c55ab;
}

.icon {

  color: #1c55ab;

}



@media (min-width: 992px) {
  .dropdown-item {
    --tw-text-opacity: 1;
    color: rgb(107 114 128 / var(--tw-text-opacity));
  }

  .dropdown-item:hover {
    --tw-bg-opacity: 1;
    /* background-color: rgb(243 244 246 / var(--tw-bg-opacity)); */
    color: #FF7800;
  }

  .dropdown:hover>.dropdown-menu {
    display: block;
  }
}

.navbar-custom .navbar-nav .active .nav-item {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.navbar-custom.is-sticky {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-shadow-color: rgb(0 0 0 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}

[data-mode="dark"] .navbar-custom.is-sticky {
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity));
}

@media (min-width: 992px) {
  .navbar-custom.is-sticky {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
}

.navbar-custom {
  /* position: fixed; */
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  z-index: 50;
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  /* background-color: rgb(31 41 55 / var(--tw-bg-opacity)); */
  background-color: transparent;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  transition-property: all;
  transition-duration: 500ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

[data-mode="dark"] .navbar-custom {
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity));
}

@media (min-width: 992px) {
  .navbar-custom {
    padding-top: 1.8rem;
    padding-bottom: 1rem;
  }
}

@media (min-width: 1200px) {
  .navbar-custom {
    background-color: transparent;
  }

  [data-mode="dark"] .navbar-custom {
    background-color: transparent;
  }
}

/* .navbar-custom .navbar-nav{
  margin-top: 1rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: end;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
} */
@media (min-width: 992px) {
  .navbar-custom .navbar-nav {
    margin-top: 0px;
    flex-direction: row;
  }

  .navbar-custom .navbar-nav> :not([hidden])~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    /* margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse))); */
  }

  .navbar-custom .navbar-nav {
    font-size: 15px;
  }
}

.navbar-custom .navbar-nav .nav-item {
  display: flex;
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity));
  padding: 0.75rem;
  color: rgba(255, 255, 255, 255);
  align-items: center;
}

.navbar-custom .navbar-nav .nav-item:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 255);
}

@media (min-width: 992px) {
  .navbar-custom .navbar-nav .nav-item {
    border-width: 0px;
  }

  .navbar-custom .navbar-nav .nav-item:hover {
    background-color: transparent;
  }
}

@media (min-width: 1200px) {
  .navbar-custom .navbar-nav .nav-item {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
}



 
  

@media (min-width: 992px) {
  .lg\\:container {
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    padding-right: 1rem;
    padding-left: 1rem;
  }

  @media (min-width: 576px) {
    .lg\\:container {
      max-width: 576px;
      padding-right: 2rem;
      padding-left: 2rem;
    }
  }

  @media (min-width: 768px) {
    .lg\\:container {
      max-width: 768px;
    }
  }

  @media (min-width: 992px) {
    .lg\\:container {
      max-width: 992px;
      padding-right: 4rem;
      padding-left: 4rem;
    }
  }

  @media (min-width: 1200px) {
    .lg\\:container {
      max-width: 1200px;
      padding-right: 5rem;
      padding-left: 5rem;
    }
  }

  @media (min-width: 1400px) {
    .lg\\:container {
      max-width: 1400px;
      padding-right: 9rem;
      padding-left: 9rem;
    }
  }
}

.marker\\:text-lg *::marker {
  font-size: 1.125rem !important;
  line-height: 1.75rem !important;
}

.marker\\:text-blue-500 *::marker {
  color: rgb(59 130 246) !important;
}

.marker\\:text-cyan-500 *::marker {
  color: rgb(6 182 212) !important;
}

.marker\\:text-green-500 *::marker {
  color: rgb(34 197 94) !important;
}

.marker\\:text-purple-500 *::marker {
  color: rgb(168 85 247) !important;
}

.marker\\:text-red-500 *::marker {
  color: rgb(239 68 68) !important;
}

.marker\\:text-yellow-500 *::marker {
  color: rgb(234 179 8) !important;
}

.marker\\:text-lg::marker {
  font-size: 1.125rem !important;
  line-height: 1.75rem !important;
}

.marker\\:text-blue-500::marker {
  color: rgb(59 130 246) !important;
}

.marker\\:text-cyan-500::marker {
  color: rgb(6 182 212) !important;
}

.marker\\:text-green-500::marker {
  color: rgb(34 197 94) !important;
}

.marker\\:text-purple-500::marker {
  color: rgb(168 85 247) !important;
}

.marker\\:text-red-500::marker {
  color: rgb(239 68 68) !important;
}

.marker\\:text-yellow-500::marker {
  color: rgb(234 179 8) !important;
}

.placeholder\\:text-sm::placeholder {
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}

.before\\:absolute::before {
  content: var(--tw-content) !important;
  position: absolute !important;
}

.before\\:left-\\[19px\\]::before {
  content: var(--tw-content) !important;
  left: 19px !important;
}

.before\\:top-11::before {
  content: var(--tw-content) !important;
  top: 2.75rem !important;
}

.before\\:top-\\[50px\\]::before {
  content: var(--tw-content) !important;
  top: 50px !important;
}

.before\\:hidden::before {
  content: var(--tw-content) !important;
  display: none !important;
}

.before\\:h-24::before {
  content: var(--tw-content) !important;
  height: 6rem !important;
}

.before\\:w-2\\/3::before {
  content: var(--tw-content) !important;
  width: 66.666667% !important;
}

.before\\:border::before {
  content: var(--tw-content) !important;
  border-width: 1px !important;
}

.before\\:border-dashed::before {
  content: var(--tw-content) !important;
  border-style: dashed !important;
}

.before\\:border-gray-300::before {
  content: var(--tw-content) !important;
  --tw-border-opacity: 1 !important;
  border-color: rgb(209 213 219 / var(--tw-border-opacity)) !important;
}

.before\\:border-red-500\\/40::before {
  content: var(--tw-content) !important;
  border-color: rgb(239 68 68 / 0.4) !important;
}

.before\\:content-\\[\\'\\'\\]::before {
  --tw-content: '' !important;
  content: var(--tw-content) !important;
}

.checked\\:bg-red-500:checked {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity)) !important;
}

.checked\\:ring-0:checked {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.checked\\:ring-offset-0:checked {
  --tw-ring-offset-width: 0px !important;
}

.hover\\:-translate-y-1:hover {
  --tw-translate-y: -0.25rem !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.hover\\:-translate-y-2:hover {
  --tw-translate-y: -0.5rem !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.hover\\:-translate-y-4:hover {
  --tw-translate-y: -1rem !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity)) !important;
}

.hover\\:bg-green-500:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity)) !important;
}

.hover\\:bg-red-500:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity)) !important;
}

.hover\\:bg-yellow-500:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity)) !important;
}

.hover\\:text-black:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity)) !important;
}

.hover\\:text-blue-500:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(59 130 246 / var(--tw-text-opacity)) !important;
}

.hover\\:text-cyan-500:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(6 182 212 / var(--tw-text-opacity)) !important;
}

.hover\\:text-gray-300:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(209 213 219 / var(--tw-text-opacity)) !important;
}

.hover\\:text-green-500:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(34 197 94 / var(--tw-text-opacity)) !important;
}

.hover\\:text-purple-500:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(168 85 247 / var(--tw-text-opacity)) !important;
}

.hover\\:text-red-500:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(239 68 68 / var(--tw-text-opacity)) !important;
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}

.hover\\:text-yellow-500:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(234 179 8 / var(--tw-text-opacity)) !important;
}

.focus\\:border-0:focus {
  border-width: 0px !important;
}

.focus\\:border-gray-400:focus {
  --tw-border-opacity: 1 !important;
  border-color: rgb(156 163 175 / var(--tw-border-opacity)) !important;
}

.focus\\:border-red-300:focus {
  --tw-border-opacity: 1 !important;
  border-color: rgb(252 165 165 / var(--tw-border-opacity)) !important;
}

.focus\\:text-black:focus {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity)) !important;
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}

.focus\\:ring:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.focus\\:ring-red-200:focus {
  --tw-ring-opacity: 1 !important;
  --tw-ring-color: rgb(254 202 202 / var(--tw-ring-opacity)) !important;
}

.focus\\:ring-opacity-50:focus {
  --tw-ring-opacity: 0.5 !important;
}

.focus\\:ring-offset-0:focus {
  --tw-ring-offset-width: 0px !important;
}

.group:hover .group-hover\\:bg-blue-500 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity)) !important;
}

.group:hover .group-hover\\:bg-cyan-500 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(6 182 212 / var(--tw-bg-opacity)) !important;
}

.group:hover .group-hover\\:bg-green-500 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity)) !important;
}

.group:hover .group-hover\\:bg-purple-500 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity)) !important;
}

.group:hover .group-hover\\:bg-red-500 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity)) !important;
}

.group:hover .group-hover\\:bg-yellow-500 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity)) !important;
}

.group:hover .group-hover\\:text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}

[dir="ltr"] .ltr\\:left-0 {
  left: 0px !important;
}

[dir="ltr"] .ltr\\:left-40 {
  left: 10rem !important;
}

[dir="ltr"] .ltr\\:right-40 {
  right: 10rem !important;
}

[dir="ltr"] .ltr\\:ml-0 {
  margin-left: 0px !important;
}

[dir="ltr"] .ltr\\:ml-2 {
  margin-left: 0.5rem !important;
}

[dir="ltr"] .ltr\\:ml-auto {
  margin-left: auto !important;
}

[dir="ltr"] .ltr\\:mr-2 {
  margin-right: 0.5rem !important;
}

[dir="ltr"] .ltr\\:hidden {
  display: none !important;
}

[dir="ltr"] .ltr\\:rotate-0 {
  --tw-rotate: 0deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

[dir="ltr"] .ltr\\:rounded-r {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}

[dir="ltr"] .ltr\\:before\\:-right-32::before {
  content: var(--tw-content) !important;
  right: -8rem !important;
}

[dir="rtl"] .rtl\\:left-40 {
  left: 10rem !important;
}

[dir="rtl"] .rtl\\:right-0 {
  right: 0px !important;
}

[dir="rtl"] .rtl\\:right-40 {
  right: 10rem !important;
}

[dir="rtl"] .rtl\\:ml-2 {
  margin-left: 0.5rem !important;
}

[dir="rtl"] .rtl\\:mr-0 {
  margin-right: 0px !important;
}

[dir="rtl"] .rtl\\:mr-2 {
  margin-right: 0.5rem !important;
}

[dir="rtl"] .rtl\\:mr-auto {
  margin-right: auto !important;
}

[dir="rtl"] .rtl\\:hidden {
  display: none !important;
}

[dir="rtl"] .rtl\\:rotate-180 {
  --tw-rotate: 180deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

[dir="rtl"] .rtl\\:rounded-l {
  border-top-left-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

[dir="rtl"] .rtl\\:before\\:-left-32::before {
  content: var(--tw-content) !important;
  left: -8rem !important;
}

[data-mode="dark"] .dark\\:block {
  display: block !important;
}

[data-mode="dark"] .dark\\:hidden {
  display: none !important;
}

[data-mode="dark"] .dark\\:border-transparent {
  border-color: transparent !important;
}

[data-mode="dark"] .dark\\:border-zinc-700\\/30 {
  border-color: rgb(63 63 70 / 0.3) !important;
}

[data-mode="dark"] .dark\\:border-zinc-700\\/50 {
  border-color: rgb(63 63 70 / 0.5) !important;
}

[data-mode="dark"] .dark\\:border-zinc-700\\/80 {
  border-color: rgb(63 63 70 / 0.8) !important;
}

[data-mode="dark"] .dark\\:bg-white {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}

[data-mode="dark"] .dark\\:bg-zinc-700 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(63 63 70 / var(--tw-bg-opacity)) !important;
}

[data-mode="dark"] .dark\\:bg-zinc-700\\/20 {
  background-color: rgb(63 63 70 / 0.2) !important;
}

[data-mode="dark"] .dark\\:bg-zinc-700\\/30 {
  background-color: rgb(63 63 70 / 0.3) !important;
}

[data-mode="dark"] .dark\\:bg-zinc-800 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity)) !important;
}

[data-mode="dark"] .dark\\:bg-zinc-900\\/20 {
  background-color: rgb(24 24 27 / 0.2) !important;
}

[data-mode="dark"] .dark\\:bg-zinc-900\\/30 {
  background-color: rgb(24 24 27 / 0.3) !important;
}

[data-mode="dark"] .dark\\:bg-zinc-900\\/40 {
  background-color: rgb(24 24 27 / 0.4) !important;
}

[data-mode="dark"] .dark\\:bg-zinc-900\\/50 {
  background-color: rgb(24 24 27 / 0.5) !important;
}

[data-mode="dark"] .dark\\:bg-zinc-900\\/60 {
  background-color: rgb(24 24 27 / 0.6) !important;
}

[data-mode="dark"] .dark\\:text-gray-300 {
  --tw-text-opacity: 1 !important;
  color: rgb(209 213 219 / var(--tw-text-opacity)) !important;
}

[data-mode="dark"] .dark\\:text-gray-300\\/50 {
  color: rgb(209 213 219 / 0.5) !important;
}

[data-mode="dark"] .dark\\:text-gray-300\\/60 {
  color: rgb(209 213 219 / 0.6) !important;
}

[data-mode="dark"] .dark\\:text-gray-300\\/80 {
  color: rgb(209 213 219 / 0.8) !important;
}

[data-mode="dark"] .dark\\:text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}

[data-mode="dark"] .dark\\:text-white\\/60 {
  color: rgb(255 255 255 / 0.6) !important;
}

[data-mode="dark"] .dark\\:text-white\\/80 {
  color: rgb(255 255 255 / 0.8) !important;
}

[data-mode="dark"] .dark\\:text-zinc-800 {
  --tw-text-opacity: 1 !important;
  color: rgb(39 39 42 / var(--tw-text-opacity)) !important;
}

[data-mode="dark"] .dark\\:placeholder\\:text-gray-300\\/50::placeholder {
  color: rgb(209 213 219 / 0.5) !important;
}

[data-mode="dark"] .dark\\:placeholder\\:text-gray-300\\/60::placeholder {
  color: rgb(209 213 219 / 0.6) !important;
}

[data-mode="dark"] .before\\:dark\\:border-zinc-700\\/50::before {
  content: var(--tw-content) !important;
  border-color: rgb(63 63 70 / 0.5) !important;
}

[data-mode="dark"] .dark\\:checked\\:bg-red-500:checked {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity)) !important;
}

@media (min-width: 768px) {
  .md\\:mx-auto {
    margin-left: auto !important;
    margin-right: auto !important;
  }

  .md\\:flex {
    display: flex !important;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  }

  .md\\:flex-row {
    flex-direction: row !important;
  }

  .md\\:justify-between {
    justify-content: space-between !important;
  }

  .md\\:text-\\[32px\\] {
    font-size: 32px !important;
  }
}

@media (min-width: 992px) {
  .lg\\:absolute {
    position: absolute !important;
  }

  .lg\\:order-1 {
    order: 1 !important;
  }

  .lg\\:order-2 {
    order: 2 !important;
  }

  .lg\\:col-span-2 {
    grid-column: span 2 / span 2 !important;
  }

  .lg\\:col-span-3 {
    grid-column: span 3 / span 3 !important;
  }

  .lg\\:col-span-5 {
    grid-column: span 5 / span 5 !important;
  }

  .lg\\:col-span-7 {
    grid-column: span 7 / span 7 !important;
  }

  .lg\\:mx-10 {
    margin-left: 2.5rem !important;
    margin-right: 2.5rem !important;
  }

  .lg\\:ml-0 {
    margin-left: 0px !important;
  }

  .lg\\:ml-14 {
    margin-left: 3.5rem !important;
  }

  .lg\\:ml-auto {
    margin-left: auto !important;
  }

  .lg\\:mr-0 {
    margin-right: 0px !important;
  }

  .lg\\:mt-0 {
    margin-top: 0px !important;
  }

  .lg\\:mt-10 {
    margin-top: 2.5rem !important;
  }

  .lg\\:block {
    display: block !important;
  }

  .lg\\:flex {
    display: flex !important;
  }

  .lg\\:grid {
    display: grid !important;
  }

  .lg\\:hidden {
    display: none !important;
  }

  .lg\\:h-auto {
    height: auto !important;
  }

  .lg\\:w-2\\/3 {
    width: 66.666667% !important;
  }

  .lg\\:w-5\\/12 {
    width: 41.666667% !important;
  }

  .lg\\:w-7\\/12 {
    width: 58.333333% !important;
  }

  .lg\\:w-auto {
    width: auto !important;
  }

  .lg\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr)) !important;
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  }

  .lg\\:flex-row {
    flex-direction: row !important;
  }

  .lg\\:flex-col {
    flex-direction: column !important;
  }

  .lg\\:justify-start {
    justify-content: flex-start !important;
  }

  .lg\\:space-x-4> :not([hidden])~ :not([hidden]) {
    --tw-space-x-reverse: 0 !important;
    margin-right: calc(1rem * var(--tw-space-x-reverse)) !important;
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse))) !important;
  }

  .lg\\:overflow-visible {
    overflow: visible !important;
  }

  .lg\\:border-0 {
    border-width: 0px !important;
  }

  .lg\\:bg-white {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
  }

  .lg\\:py-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .lg\\:py-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }

  .lg\\:py-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .lg\\:pb-32 {
    padding-bottom: 8rem !important;
  }

  .lg\\:pb-40 {
    padding-bottom: 10rem !important;
  }

  .lg\\:pr-10 {
    padding-right: 2.5rem !important;
  }

  .lg\\:pr-\\[17px\\] {
    padding-right: 17px !important;
  }

  .lg\\:pt-56 {
    padding-top: 14rem !important;
  }

  .lg\\:text-left {
    text-align: left !important;
  }

  .lg\\:text-center {
    text-align: center !important;
  }

  .lg\\:text-\\[15px\\] {
    font-size: 15px !important;
  }

  .lg\\:text-\\[46px\\] {
    font-size: 46px !important;
  }

  .lg\\:text-gray-500 {
    --tw-text-opacity: 1 !important;
    color: rgb(107 114 128 / var(--tw-text-opacity)) !important;
  }

  .lg\\:shadow-lg {
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1) !important;
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
  }

  .before\\:lg\\:block::before {
    content: var(--tw-content) !important;
    display: block !important;
  }

  .lg\\:hover\\:bg-gray-100:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(243 244 246 / var(--tw-bg-opacity)) !important;
  }

  .lg\\:hover\\:bg-transparent:hover {
    background-color: transparent !important;
  }

  [dir="ltr"] .ltr\\:lg\\:ml-14 {
    margin-left: 3.5rem !important;
  }

  [dir="ltr"] .ltr\\:lg\\:ml-auto {
    margin-left: auto !important;
  }

  [dir="ltr"] .ltr\\:lg\\:text-right {
    text-align: right !important;
  }

  [dir="rtl"] .rtl\\:lg\\:mr-14 {
    margin-right: 3.5rem !important;
  }

  [dir="rtl"] .rtl\\:lg\\:mr-auto {
    margin-right: auto !important;
  }

  [dir="rtl"] .rtl\\:lg\\:text-left {
    text-align: left !important;
  }
}

@media (min-width: 1200px) {
  .xl\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .xl\\:bg-transparent {
    background-color: transparent !important;
  }

  [data-mode="dark"] .dark\\:xl\\:bg-transparent {
    background-color: transparent !important;
  }
}

/* @media (max-width: 1250px) {
  .Heading-02 {
    font-size: 45px;
  }
} */

@media (max-width: 1190px) {
  

  .elementor-motion-effects-layer2 {
    background-position: 481% -328px;
  }
}

@media (max-width: 1024px) {
  .react-multiple-carousel__arrow {
    display: none;
  }

  /* li.react-multi-carousel-item {
    margin-right: 15px;
  } */
}

/* responsive */

@media (max-width: 1191px) {

  .Heading-01 {
    font-size: 50px;
  }

  .heading-para {
    font-size: 12px;
  }

  .bbt {
    border-radius: 6px;
    height: 49px;
  }
}

@media (max-width: 1042px) {

  .Heading-01 {
    font-size: 40px;
  }

  .heading-para {
    font-size: 12px;
  }

}

@media (max-width: 992px) {
  .heading-para {
    display: none;
  }

  .Heading-01 {
    font-size: 33px;
  }

  .dropdown-menu {
    position: absolute;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}

@media (max-width: 767px){
  /* .available-app-area{
    padding-top: 50px;
    padding-bottom: 50px;
  } */
  .section-tittle h2{
    font-size: 35px;
  }
  
}

@media (max-width:597px) {
  .Heading-01 {
    font-size: 25px;
  }

  .slider {
    padding: 0;
    margin: 0 10px !important;
  }
  .section-tittle h2 {
    font-size: 26px;
}
.Heading-02 {
  font-size: 38px;
}
.paragraph {
  font-size: 16px;
  color: #737e8c;
}
.elementor-icon-list-text{
  font-size: 16px;
}
.Secure {
  position: relative;
  top: 2px;
  height: 91px;
}
.simple {
  position: relative;
  top: -4px;
  height: 65px;
}
.Reliable {
  position: relative;
  top: 4px;
  height: 64px !important;
}
}

@media (max-width:480px) {
  .Heading-01 {
    font-size: 20px;
  }
}

.carousel-item-padding-40-px {
  height: 100%;
  align-items: center;
  display: flex;
}
/* .react-multi-carousel-track{
  gap: 15px;
} */

/* @media (max-width: 480px){
  li.react-multi-carousel-item{
    width: 155px !important;
  }
} */


.radio-button-label > input { 
	display: none;
}
.radio-button-label > img {
	cursor: pointer;
	/* border: 3px solid #ddd; */
	/* width: 100px; */
}

.radio-button-label > input:checked + img {
  border: 3px solid #efcfb2 !important;
  background: #fff;
  padding: 2px;
  box-shadow: 2px 8px 8px 2px #c1c1c194;
  border-radius: 7px;
 
}


`, "",{"version":3,"sources":["webpack://./src/tailwind.css"],"names":[],"mappings":"AAAA;;CAEC;AACD;;EAEE,YAAY;AACd;;AAEA;;;CAGC;AACD;EACE,6BAA6B;EAC7B,MAAM;EACN,oBAAoB;EACpB,MAAM;AACR;;AAEA;;CAEC;AACD;EACE,wBAAwB;AAC1B;;AAEA;;;CAGC;AACD;EACE,0BAA0B;EAC1B,MAAM;EACN,aAAa;EACb,MAAM;AACR;;AAEA;;CAEC;AACD;EACE,kBAAkB;AACpB;;AAEA;;CAEC;AACD;;;;;;;;;;;;;EAaE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;;CAEC;AACD;EACE,gBAAgB;AAClB;;AAEA;;;CAGC;;AAiCD;;EAEE,UAAU;EACV,MAAM;EACN,cAAc;EACd,MAAM;AACR;;AAEA;;CAEC;AACD;;EAEE,eAAe;AACjB;;AAEA;;CAEC;AACD;EACE,eAAe;AACjB;;AAEA;;;;CAIC;AACD;;;;;;;;EAQE,cAAc;EACd,MAAM;EACN,sBAAsB;EACtB,MAAM;AACR;;AAEA;;CAEC;AACD;;EAEE,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA,wEAAwE;AACxE;EACE,aAAa;AACf;;AAEA;;;;;;;;;;;;;;;EAiBE,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;;;;;;;;;;;;;;EAeE,8BAA8B;EAC9B,mBAAmB;EACnB;;;KAGG;EACH,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;EACxB,2GAA2G;EAC3G,yGAAyG;EAEzG,iFAAiF;EACjF,qBAAqB;AACvB;;AA0BA;;EAEE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yDAAmP;EACnP,wCAAwC;EACxC,4BAA4B;EAC5B,4BAA4B;EAC5B,qBAAqB;EACrB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,iCAAiC;EACjC,mBAAmB;AACrB;;;AAGA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;;EAGE,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,sCAAsC;EACtC,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,2BAA2B;EAC3B,4BAA4B;EAC5B,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;EAC1B,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;AACvB;;AAiDA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,sCAAsC;EACtC,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,2BAA2B;EAC3B,4BAA4B;EAC5B,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;EAC1B,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;;;AAIA;EACE,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EAGzB,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;EACpB,8BAA8B;EAC9B,mBAAmB;EAEnB,wBAAwB;EAExB,wDAAwD;EAExD,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAE3B,+LAA+L;AACjM;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,2GAA2G;EAC3G,yGAAyG;EAEzG,4FAA4F;EAC5F,2BAA2B;AAC7B;;AAEA;EAEE,wBAAwB;EAExB,wDAAwD;EAExD,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAE3B,+LAA+L;AACjM;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ;2BACyB;EACzB,6BAA6B;;EAE7B,sBAAsB;EACtB,8BAA8B;EAE9B,uGAAuG;AACzG;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;;;AAGpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;;;AAGpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;;AAEpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;;AAEpB;;AAEA;EACE,eAAe;EACf,cAAc;;;AAGhB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yDAA6D;EAC7D,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;;AAGA;;GAEG;;AAEH;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EAIrB,mEAAmE;EAEnE,uEAAuE;AALzE;;AAQA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;;AAElB;;AAEA;EACE;IACE,kBAAkB;IAClB,SAAS;IACT,uBAAuB;AAC3B;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;;EAEE;IACE,kBAAkB;IAClB,SAAS;AACb;;EAEE;;;KAGG;;AAEL;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;;AAGA;EACE;IACE,kBAAkB;IAClB,kBAAkB;IAClB,yDAAyD;IACzD,mBAAmB;IACnB,sBAAsB;IACtB,+EAA+E;IAC/E,mGAAmG;IAEnG,uGAAuG;EACzG;AACF;;AAEA;EAEE,6BAA6B;EAE7B,wBAAwB;EAExB,yBAAyB;AAC3B;;AAgBA;EACE;IACE,UAAU;IAEV,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IAEV,2BAA2B;EAC7B;AACF;;AAEA;;GAEG;;AAEH;EACE,oBAAoB;EAEpB,+LAA+L;EAC/L,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,0BAA0B;EAC1B,oBAAoB;EACpB,gDAAgD;EAGhD,8GAA8G;EAG9G,wDAAwD;EAExD,0BAA0B;;;AAG5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;;GAIG;;AAEH;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,yDAA2D;EAC3D,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;;AAEhC;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EAInB,eAAe;EACf,gBAAgB;EAChB,cAAc;AALhB;;AAQA;;EAEE,cAAc;;AAEhB;;;;AAIA;EACE;IACE,oBAAoB;IACpB,gDAAgD;EAClD;;EAEA;IACE,kBAAkB;IAClB,+DAA+D;IAC/D,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;EACtD,0CAA0C;EAC1C,uDAAuD;EAEvD,uGAAuG;EACvG,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE;IACE,oBAAoB;IACpB,uBAAuB;EACzB;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,yDAAyD;EACzD,kBAAkB;EAClB,4DAA4D;EAC5D,6BAA6B;EAC7B,oBAAoB;EACpB,uBAAuB;EAEvB,wBAAwB;EAExB,0BAA0B;EAE1B,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE;IACE,mBAAmB;IACnB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;;;;;;;;;;GAUG;AACH;EACE;IACE,eAAe;IAIf,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,oDAAoD;IACpD,mEAAmE;EACrE;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yDAAyD;EACzD,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;;;;;;AAOA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE;MACE,gBAAgB;MAChB,mBAAmB;MACnB,kBAAkB;IACpB;EACF;;EAEA;IACE;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE;MACE,gBAAgB;MAChB,mBAAmB;MACnB,kBAAkB;IACpB;EACF;;EAEA;IACE;MACE,iBAAiB;MACjB,mBAAmB;MACnB,kBAAkB;IACpB;EACF;;EAEA;IACE;MACE,iBAAiB;MACjB,mBAAmB;MACnB,kBAAkB;IACpB;EACF;AACF;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAsBA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,oEAAoE;AACtE;;AAEA;EACE,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,6BAA6B;EAC7B,kEAAkE;AACpE;;AAEA;EACE,sHAAsH;EACtH,oHAAoH;EAEpH,uGAAuG;AACzG;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EAErC,0MAA0M;AAC5M;;AAEA;EACE,oCAAoC;EAEpC,0MAA0M;AAC5M;;AAEA;EACE,kCAAkC;EAElC,0MAA0M;AAC5M;;AAEA;EACE,6BAA6B;EAC7B,kEAAkE;AACpE;;AAEA;EACE,6BAA6B;EAC7B,kEAAkE;AACpE;;AAEA;EACE,6BAA6B;EAC7B,kEAAkE;AACpE;;AAEA;EACE,6BAA6B;EAC7B,kEAAkE;AACpE;;AAEA;EACE,+BAA+B;EAC/B,qDAAqD;AACvD;;AAEA;EACE,+BAA+B;EAC/B,0DAA0D;AAC5D;;AAEA;EACE,+BAA+B;EAC/B,yDAAyD;AAC3D;;AAEA;EACE,+BAA+B;EAC/B,2DAA2D;AAC7D;;AAEA;EACE,+BAA+B;EAC/B,yDAAyD;AAC3D;;AAEA;EACE,+BAA+B;EAC/B,0DAA0D;AAC5D;;AAEA;EACE,+BAA+B;EAC/B,yDAAyD;AAC3D;;AAEA;EACE,+BAA+B;EAC/B,2DAA2D;AAC7D;;AAEA;EACE,+BAA+B;EAC/B,yDAAyD;AAC3D;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,oEAAoE;AACtE;;AAEA;EACE,iCAAiC;EACjC,oEAAoE;AACtE;;AAEA;EACE,+BAA+B;EAC/B,qDAAqD;AACvD;;AAEA;EACE,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE,sHAAsH;EACtH,oHAAoH;EAEpH,uGAAuG;AACzG;;AAEA;EACE,sHAAsH;EACtH,oHAAoH;EAEpH,uGAAuG;AACzG;;AAEA;EACE,+BAA+B;EAC/B,qEAAqE;AACvE;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;EAC7B,mEAAmE;AACrE;;AAEA;EACE,6BAA6B;EAC7B,kEAAkE;AACpE;;AAEA;EACE,6BAA6B;EAC7B,kEAAkE;AACpE;;AAEA;EACE,6BAA6B;EAC7B,mEAAmE;AACrE;;AAEA;EACE,6BAA6B;EAC7B,kEAAkE;AACpE;;AAEA;EACE,6BAA6B;EAC7B,kEAAkE;AACpE;;AAEA;EACE,+BAA+B;EAC/B,2DAA2D;AAC7D;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAE5B,0MAA0M;AAC5M;;AAEA;EACE,2CAA2C;EAC3C,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAE9B,0MAA0M;AAC5M;;AAEA;EACE,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,6BAA6B;EAC7B,oEAAoE;AACtE;;AAEA;EACE,6BAA6B;EAC7B,iEAAiE;AACnE;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,6BAA6B;EAC7B,iEAAiE;AACnE;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,+BAA+B;EAC/B,2DAA2D;AAC7D;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,+BAA+B;EAC/B,2DAA2D;AAC7D;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,+BAA+B;EAC/B,wDAAwD;AAC1D;;AAkBA;EACE,wCAAwC;AAC1C;;AAkBA;EACE,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,6BAA6B;EAC7B,kEAAkE;AACpE;;AAEA;EACE;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA;IAGE,wBAAwB;EAC1B;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IAIE,8BAA8B;EAChC;;EAEA;IAGE,yCAAyC;EAC3C;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;EACrB;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IAGE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,4DAA4D;EAC9D;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IAIE,8BAA8B;EAChC;;EAEA;IAIE,iCAAiC;EACnC;;EAEA;IAGE,sCAAsC;EACxC;;EAEA;IACE,kCAAkC;IAClC,+DAA+D;IAC/D,wEAAwE;EAC1E;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,oEAAoE;EACtE;;EAEA;IACE,8BAA8B;IAC9B,iCAAiC;EACnC;;EAEA;IACE,+BAA+B;IAC/B,kCAAkC;EACpC;;EAEA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,+BAA+B;IAC/B,2DAA2D;EAC7D;;EAEA;IACE,0FAA0F;IAC1F,8GAA8G;IAE9G,kHAAkH;EACpH;;EAEA;IACE,qCAAqC;IACrC,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;IAC7B,oEAAoE;EACtE;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,2DAA2D;EAC7D;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,wCAAwC;EAC1C;AACF;;AAEA;;;;GAIG;;AAEH;;;EAGE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;KAEG;AACL;;AAEA,eAAe;;AAEf;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;AACF;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,yDAAyD;IACzD,mBAAmB;IACnB,sBAAsB;IACtB,+EAA+E;IAC/E,mGAAmG;IAEnG,uGAAuG;EACzG;AACF;;AAEA;EACE;;;KAGG;EACH;IACE,eAAe;EACjB;;AAEF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,yBAAyB;EAC3B;EACA;IACE,eAAe;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,uBAAuB;AACzB;AACA;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;AACA;;GAEG;;AAEH;;;;GAIG;;;AAGH;CACC,aAAa;AACd;AACA;CACC,eAAe;CACf,4BAA4B;CAC5B,kBAAkB;AACnB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;;AAEpB","sourcesContent":["/*\nCorrect the cursor style of increment and decrement buttons in Safari.\n*/\n::-webkit-inner-spin-button,\n::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/*\n1. Correct the odd appearance in Chrome and Safari.\n2. Correct the outline style in Safari.\n*/\n[type='search'] {\n  -webkit-appearance: textfield;\n  /* 1 */\n  outline-offset: -2px;\n  /* 2 */\n}\n\n/*\nRemove the inner padding in Chrome and Safari on macOS.\n*/\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/*\n1. Correct the inability to style clickable types in iOS and Safari.\n2. Change font properties to `inherit` in Safari.\n*/\n::-webkit-file-upload-button {\n  -webkit-appearance: button;\n  /* 1 */\n  font: inherit;\n  /* 2 */\n}\n\n/*\nAdd the correct display in Chrome and Safari.\n*/\nsummary {\n  display: list-item;\n}\n\n/*\nRemoves the default spacing and border for appropriate elements.\n*/\nblockquote,\ndl,\ndd,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nhr,\nfigure,\np,\npre {\n  margin: 0;\n}\n\nfieldset {\n  margin: 0;\n  padding: 0;\n}\n\nlegend {\n  padding: 0;\n}\n\nol,\nul,\nmenu {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n/*\nPrevent resizing textareas horizontally by default.\n*/\ntextarea {\n  resize: vertical;\n}\n\n/*\n1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n2. Set the default placeholder color to the user's configured gray 400 color.\n*/\ninput::-webkit-input-placeholder,\ntextarea::-webkit-input-placeholder {\n  opacity: 1;\n  /* 1 */\n  color: #9ca3af;\n  /* 2 */\n}\n\ninput::-moz-placeholder,\ntextarea::-moz-placeholder {\n  opacity: 1;\n  /* 1 */\n  color: #9ca3af;\n  /* 2 */\n}\n\ninput:-ms-input-placeholder,\ntextarea:-ms-input-placeholder {\n  opacity: 1;\n  /* 1 */\n  color: #9ca3af;\n  /* 2 */\n}\n\ninput::-ms-input-placeholder,\ntextarea::-ms-input-placeholder {\n  opacity: 1;\n  /* 1 */\n  color: #9ca3af;\n  /* 2 */\n}\n\ninput::placeholder,\ntextarea::placeholder {\n  opacity: 1;\n  /* 1 */\n  color: #9ca3af;\n  /* 2 */\n}\n\n/*\nSet the default cursor for buttons.\n*/\nbutton,\n[role=\"button\"] {\n  cursor: pointer;\n}\n\n/*\nMake sure disabled buttons don't get the pointer cursor.\n*/\n:disabled {\n  cursor: default;\n}\n\n/*\n1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n   This can trigger a poorly considered lint error in some tools but is included by design.\n*/\nimg,\nsvg,\nvideo,\ncanvas,\naudio,\niframe,\nembed,\nobject {\n  display: block;\n  /* 1 */\n  vertical-align: middle;\n  /* 2 */\n}\n\n/*\nConstrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\nimg,\nvideo {\n  max-width: 100%;\n  height: auto;\n  width: 100%;\n}\n\n/* Make elements with the HTML hidden attribute stay hidden by default */\n[hidden] {\n  display: none;\n}\n\n[type='text'],\n[type='email'],\n[type='url'],\n[type='password'],\n[type='number'],\n[type='date'],\n[type='datetime-local'],\n[type='month'],\n[type='search'],\n[type='tel'],\n[type='time'],\n[type='week'],\n[multiple],\ntextarea,\nselect {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-color: #fff;\n  border-color: #6b7280;\n  border-width: 1px;\n  border-radius: 0px;\n  padding-top: 0.5rem;\n  padding-right: 0.75rem;\n  padding-bottom: 0.5rem;\n  padding-left: 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  --tw-shadow: 0 0 #0000;\n}\n\n[type='text']:focus,\n[type='email']:focus,\n[type='url']:focus,\n[type='password']:focus,\n[type='number']:focus,\n[type='date']:focus,\n[type='datetime-local']:focus,\n[type='month']:focus,\n[type='search']:focus,\n[type='tel']:focus,\n[type='time']:focus,\n[type='week']:focus,\n[multiple]:focus,\ntextarea:focus,\nselect:focus {\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n  --tw-ring-inset: var(--tw-empty,\n      /*!*/\n      /*!*/\n    );\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: #2563eb;\n  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\n  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);\n  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);\n  border-color: #2563eb;\n}\n\ninput::-webkit-input-placeholder,\ntextarea::-webkit-input-placeholder {\n  color: #6b7280;\n  opacity: 1;\n}\n\ninput::-moz-placeholder,\ntextarea::-moz-placeholder {\n  color: #6b7280;\n  opacity: 1;\n}\n\ninput:-ms-input-placeholder,\ntextarea:-ms-input-placeholder {\n  color: #6b7280;\n  opacity: 1;\n}\n\ninput::-ms-input-placeholder,\ntextarea::-ms-input-placeholder {\n  color: #6b7280;\n  opacity: 1;\n}\n\ninput::placeholder,\ntextarea::placeholder {\n  color: #6b7280;\n  opacity: 1;\n}\n\n::-webkit-datetime-edit-fields-wrapper {\n  padding: 0;\n}\n\n::-webkit-date-and-time-value {\n  min-height: 1.5em;\n}\n\nselect {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e\");\n  background-position: right 0.5rem center;\n  background-repeat: no-repeat;\n  background-size: 1.5em 1.5em;\n  padding-right: 2.5rem;\n  -webkit-print-color-adjust: exact;\n  color-adjust: exact;\n}\n\n[multiple] {\n  background-image: initial;\n  background-position: initial;\n  background-repeat: unset;\n  background-size: initial;\n  padding-right: 0.75rem;\n  -webkit-print-color-adjust: unset;\n  color-adjust: unset;\n}\n\n\n[type='file'] {\n  background: unset;\n  border-color: inherit;\n  border-width: 0;\n  border-radius: 0;\n  padding: 0;\n  font-size: unset;\n  line-height: inherit;\n}\n\n[type='file']:focus {\n  outline: 1px auto -webkit-focus-ring-color;\n}\n\n*,\n::before,\n::after {\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x: ;\n  --tw-pan-y: ;\n  --tw-pinch-zoom: ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-ordinal: ;\n  --tw-slashed-zero: ;\n  --tw-numeric-figure: ;\n  --tw-numeric-spacing: ;\n  --tw-numeric-fraction: ;\n  --tw-ring-inset: ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgb(59 130 246 / 0.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur: ;\n  --tw-brightness: ;\n  --tw-contrast: ;\n  --tw-grayscale: ;\n  --tw-hue-rotate: ;\n  --tw-invert: ;\n  --tw-saturate: ;\n  --tw-sepia: ;\n  --tw-drop-shadow: ;\n  --tw-backdrop-blur: ;\n  --tw-backdrop-brightness: ;\n  --tw-backdrop-contrast: ;\n  --tw-backdrop-grayscale: ;\n  --tw-backdrop-hue-rotate: ;\n  --tw-backdrop-invert: ;\n  --tw-backdrop-opacity: ;\n  --tw-backdrop-saturate: ;\n  --tw-backdrop-sepia: ;\n}\n\n::-webkit-backdrop {\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x: ;\n  --tw-pan-y: ;\n  --tw-pinch-zoom: ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-ordinal: ;\n  --tw-slashed-zero: ;\n  --tw-numeric-figure: ;\n  --tw-numeric-spacing: ;\n  --tw-numeric-fraction: ;\n  --tw-ring-inset: ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgb(59 130 246 / 0.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur: ;\n  --tw-brightness: ;\n  --tw-contrast: ;\n  --tw-grayscale: ;\n  --tw-hue-rotate: ;\n  --tw-invert: ;\n  --tw-saturate: ;\n  --tw-sepia: ;\n  --tw-drop-shadow: ;\n  --tw-backdrop-blur: ;\n  --tw-backdrop-brightness: ;\n  --tw-backdrop-contrast: ;\n  --tw-backdrop-grayscale: ;\n  --tw-backdrop-hue-rotate: ;\n  --tw-backdrop-invert: ;\n  --tw-backdrop-opacity: ;\n  --tw-backdrop-saturate: ;\n  --tw-backdrop-sepia: ;\n}\n\n::backdrop {\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x: ;\n  --tw-pan-y: ;\n  --tw-pinch-zoom: ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-ordinal: ;\n  --tw-slashed-zero: ;\n  --tw-numeric-figure: ;\n  --tw-numeric-spacing: ;\n  --tw-numeric-fraction: ;\n  --tw-ring-inset: ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgb(59 130 246 / 0.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur: ;\n  --tw-brightness: ;\n  --tw-contrast: ;\n  --tw-grayscale: ;\n  --tw-hue-rotate: ;\n  --tw-invert: ;\n  --tw-saturate: ;\n  --tw-sepia: ;\n  --tw-drop-shadow: ;\n  --tw-backdrop-blur: ;\n  --tw-backdrop-brightness: ;\n  --tw-backdrop-contrast: ;\n  --tw-backdrop-grayscale: ;\n  --tw-backdrop-hue-rotate: ;\n  --tw-backdrop-invert: ;\n  --tw-backdrop-opacity: ;\n  --tw-backdrop-saturate: ;\n  --tw-backdrop-sepia: ;\n}\n\n.container {\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: 1rem;\n  padding-left: 1rem;\n}\n\n@media (min-width: 576px) {\n  .container {\n    max-width: 576px;\n    padding-right: 2rem;\n    padding-left: 2rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .container {\n    max-width: 768px;\n  }\n}\n\n@media (min-width: 992px) {\n  .container {\n    max-width: 992px;\n    padding-right: 4rem;\n    padding-left: 4rem;\n  }\n}\n\n@media (min-width: 1200px) {\n  .container {\n    max-width: 1200px;\n    padding-right: 5rem;\n    padding-left: 5rem;\n  }\n}\n\n@media (min-width: 1400px) {\n  .container {\n    max-width: 1400px;\n    padding-right: 9rem;\n    padding-left: 9rem;\n  }\n}\n\n\n\n.btn {\n  display: inline-block;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  border-radius: 0.25rem;\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n  padding-top: 0.625rem;\n  padding-bottom: 0.625rem;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n  -webkit-transition-property: all;\n  transition-property: all;\n  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  -webkit-transition-duration: 500ms;\n  transition-duration: 500ms;\n}\n\n.btn:hover {\n  --tw-translate-y: -0.375rem;\n  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.btn:focus {\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\n  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);\n  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);\n  --tw-ring-offset-width: 0px;\n}\n\n.slideuphover {\n  -webkit-transition-property: all;\n  transition-property: all;\n  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  -webkit-transition-duration: 500ms;\n  transition-duration: 500ms;\n}\n\n.slideuphover:hover {\n  --tw-translate-y: -0.375rem;\n  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.dropdown {\n  position: relative;\n}\n\n.dropdown-menu {\n  position: static;\n  z-index: 20;\n  display: none;\n  text-align: left;\n  width: 14rem;\n  /*   \n  border-radius: 0.25rem; */\n  background-color: transparent;\n\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  -webkit-box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n\n.navbar-custom .navbar-nav .nav-item {\n  color: #fff;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: 1.5;\n  word-spacing: 1.5;\n}\n\n.navbar-custom .navbar-nav .nav-item:hover {\n  color: #FF7800;\n}\n\n.Get-button {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 1em;\n  color: #FFFFFF;\n  background-color: #1C6EEE00;\n  border: 3px solid;\n  border-radius: 3px;\n  padding: 14px 20px 14px 20px;\n}\n\n.elementor-animation-float {\n  transition-duration: .3s;\n  transition-property: transform;\n  transition-timing-function: ease-out;\n}\n\n.elementor-animation-float:hover {\n  transform: translateY(-8px);\n}\n\n.Heading-01 {\n\n  color: white;\n  font-size: 66px;\n  font-weight: 600;\n  line-height: 1.3em;\n\n\n}\n\n.Heading-02 {\n  color: #0b1622;\n  font-size: 52px;\n  font-weight: 600;\n  line-height: 1.2em;\n\n\n}\n\n.heading-title {\n  color: #ffffff;\n  font-size: 40px;\n  font-weight: 600;\n  line-height: 1.3em;\n \n}\n\n.heading-para {\n  color: #b3b5b9;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 2.05em;\n  /* letter-spacing: 0.1rem; */\n}\n\n.sub-titles {\n  color: #0b1622;\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 1.2em;\n  \n}\n\n.paragraph {\n  font-size: 16px;\n  color: #737e8c;\n\n\n}\n\n.bbt {\n  border-radius: 6px;\n  height: 54px;\n}\n\n.bbt:hover {\n  border-radius: 6px;\n  height: 54px;\n}\n\n.fearure-head {\n  font-size: 22px;\n  font-weight: 600;\n  color: #0b1622;\n}\n\n.fearure-head2 {\n  font-size: 22px;\n  font-weight: 200;\n  color: #0b1622;\n}\n\n.feature-para {\n  font-size: 15px;\n  font-weight: 500;\n  color: #737e8c;\n}\n\n.elementor-icon-list-item {\n  display: flex;\n  align-items: center;\n}\n\n.elementor-icon-list-text {\n  font-weight: 600;\n  font-size: 20px;\n  color: #0b1622;\n  letter-spacing: 0.03rem;\n}\n\nh6.elementor-heading-title {\n  font-weight: 600;\n  font-size: 18px;\n  letter-spacing: 0.03rem;\n  color: #0b1622;\n}\n\n.elementor-motion-effects-layer {\n  background-color: #1c55ab;\n  background-image: url(\"./assets/images/ornament-7-1-min.png\");\n  background-position: top left;\n  background-repeat: no-repeat;\n}\n\n.react-player__preview {\n  border-radius: 10px;\n}\n\n.react-player__preview button {\n  font-size: 135px;\n  color: #ffffffb5;\n}\n\nh5.misium-head {\n  font-size: 25px;\n  font-weight: 600;\n  letter-spacing: 0.02rem;\n  color: #0b1622;\n  line-height: 1.9rem;\n}\n#flip {\n  height: 61px;\n  overflow: hidden;\n  position: absolute;\n  left: 0s;\n  top: auto !important;\n}\n\n#flip>div>div {\n  color: #fff;\n  padding: 13px 12px;\n  height: 59px;\n  margin-bottom: 30px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 800;\n}\n\n\n/* #flip div:nth-child(2) {\n  animation: show 8s linear infinite;\n} */\n\n#flip div:first-child {\n  animation: show 5s linear infinite;\n}\n\n.available-app-area {\n  position: relative;\n  padding-top: 100px;\n  padding-bottom: 100px;\n}\n\n.available-app-area {\n  background-image: linear-gradient(90deg, #095bc1 33%, #00d4ff 100%);\n  background-image: -webkit-linear-gradient(90deg, #095bc1 33%, #00d4ff 100%);\n  background-image: -ms-linear-gradient(90deg, #095bc1 33%, #00d4ff 100%);\n}\n\n.available-app-area .app-caption .section-tittle3 h2 {\n  color: #fff;\n  margin-bottom: 8px;\n  font-weight: 600;\n}\n.section-tittle h2 {\n  font-size: 50px;\n  font-weight: 700;\n  line-height: 1.2;\n \n}\n\n@media (max-width: 991px) {\n  .Reliable {\n    position: relative;\n    top: -6px;\n    height: 68px !important;\n}\n.Secure {\n  position: relative;\n  top: -9px;\n}\n\n  .simple {\n    position: relative;\n    top: -4px;\n}\n\n  /* #flip {\n    top: 26px;\n\n  } */\n\n}\n\n#flip div div {\n  color: #42c58a;\n}\n\n#flip div:first-child div {\n  color: #4ec7f3;\n}\n\n#flip div:last-child div {\n  color: #eabb76;\n}\n\nul.mobile-link li:hover {\n  color: #fd7701;\n}\n\n@keyframes show {\n  0% {\n    margin-top: -270px;\n  }\n\n  5% {\n    margin-top: -180px;\n  }\n\n  33% {\n    margin-top: -180px;\n  }\n\n  38% {\n    margin-top: -90px;\n  }\n\n  66% {\n    margin-top: -90px;\n  }\n\n  71% {\n    margin-top: 0px;\n  }\n\n  99.99% {\n    margin-top: 0px;\n  }\n\n  100% {\n    margin-top: -270px;\n  }\n}\n\n\n@media (min-width: 992px) {\n  .dropdown-menu {\n    position: absolute;\n    --tw-bg-opacity: 1;\n    background-color: rgb(255 255 255 / var(--tw-bg-opacity));\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);\n    -webkit-box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n  }\n}\n\n.dropdown-menu {\n  -webkit-animation-name: DropDownSlide;\n  animation-name: DropDownSlide;\n  -webkit-animation-duration: 0.4s;\n  animation-duration: 0.4s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes DropDownSlide {\n  100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n  }\n\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(10px);\n    transform: translateY(10px);\n  }\n}\n\n@keyframes DropDownSlide {\n  100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n  }\n\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(10px);\n    transform: translateY(10px);\n  }\n}\n\n/* .dropdown-menu.show{\n  display: block;\n} */\n\n.dropdown-item {\n  /* display: block; */\n  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n  padding-left: 1rem;\n  padding-right: 1rem;\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  font-size: 1.0rem;\n  line-height: 1.25rem;\n  text-transform: capitalize;\n  --tw-text-opacity: 1;\n  color: rgb(156 163 175 / var(--tw-text-opacity));\n  -webkit-transition-property: color, background-color, border-color, outline-color, fill, stroke, -webkit-text-decoration-color;\n  transition-property: color, background-color, border-color, outline-color, fill, stroke, -webkit-text-decoration-color;\n  transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke;\n  transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, -webkit-text-decoration-color;\n  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  -webkit-transition-duration: 200ms;\n  transition-duration: 200ms;\n\n\n}\n\n.dropdown-item:hover {\n  background-color: transparent;\n}\n\n/* .dropdown-item:hover {\n  animation-name: DropDownSlide;\n  animation-duration: 0.4s;\n  animation-fill-mode: both;\n} */\n\n.dropdown-menu li:hover {\n  color: #fe7b05;\n}\n\n.small-head {\n  color: #737e8c;\n  margin: 0px 0px 20px 0px;\n  padding: 2px 10px 2px 10px;\n  background-color: #0d20360d;\n  border-radius: 3px 3px 3px 3px;\n  font-weight: 600;\n  line-height: 0.1em;\n  font-size: 12px;\n}\n\n.elementor-motion-effects-layer2 {\n  background-color: #fff;\n  background-image: url(./assets//images//ornament-8-min.png);\n  background-position: 155% -192px;\n  background-repeat: no-repeat;\n  /* background-size: contain; */\n\n}\n\n.menu-item li {\n  color: #ffffff99;\n  font-size: 14px;\n}\n\n.scrollToTop {\n  background: #1c55ab;\n  position: absolute;\n  color: #fff;\n}\n\n.num {\n  display: flex;\n  align-items: center;\n}\n\n.num {\n  font-size: 55px;\n  font-weight: 700;\n  color: #1c55ab;\n}\n\n.icon {\n\n  color: #1c55ab;\n\n}\n\n\n\n@media (min-width: 992px) {\n  .dropdown-item {\n    --tw-text-opacity: 1;\n    color: rgb(107 114 128 / var(--tw-text-opacity));\n  }\n\n  .dropdown-item:hover {\n    --tw-bg-opacity: 1;\n    /* background-color: rgb(243 244 246 / var(--tw-bg-opacity)); */\n    color: #FF7800;\n  }\n\n  .dropdown:hover>.dropdown-menu {\n    display: block;\n  }\n}\n\n.navbar-custom .navbar-nav .active .nav-item {\n  --tw-text-opacity: 1;\n  color: rgb(255 255 255 / var(--tw-text-opacity));\n}\n\n.navbar-custom.is-sticky {\n  --tw-bg-opacity: 1;\n  background-color: rgb(31 41 55 / var(--tw-bg-opacity));\n  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);\n  -webkit-box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n  --tw-shadow-color: rgb(0 0 0 / 0.3);\n  --tw-shadow: var(--tw-shadow-colored);\n}\n\n[data-mode=\"dark\"] .navbar-custom.is-sticky {\n  --tw-bg-opacity: 1;\n  background-color: rgb(39 39 42 / var(--tw-bg-opacity));\n}\n\n@media (min-width: 992px) {\n  .navbar-custom.is-sticky {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n}\n\n.navbar-custom {\n  /* position: fixed; */\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  z-index: 50;\n  --tw-border-opacity: 1;\n  border-color: rgb(229 231 235 / var(--tw-border-opacity));\n  --tw-bg-opacity: 1;\n  /* background-color: rgb(31 41 55 / var(--tw-bg-opacity)); */\n  background-color: transparent;\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  -webkit-transition-property: all;\n  transition-property: all;\n  -webkit-transition-duration: 500ms;\n  transition-duration: 500ms;\n  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n[data-mode=\"dark\"] .navbar-custom {\n  --tw-bg-opacity: 1;\n  background-color: rgb(39 39 42 / var(--tw-bg-opacity));\n}\n\n@media (min-width: 992px) {\n  .navbar-custom {\n    padding-top: 1.8rem;\n    padding-bottom: 1rem;\n  }\n}\n\n@media (min-width: 1200px) {\n  .navbar-custom {\n    background-color: transparent;\n  }\n\n  [data-mode=\"dark\"] .navbar-custom {\n    background-color: transparent;\n  }\n}\n\n/* .navbar-custom .navbar-nav{\n  margin-top: 1rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  justify-content: end;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n} */\n@media (min-width: 992px) {\n  .navbar-custom .navbar-nav {\n    margin-top: 0px;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: row;\n    flex-direction: row;\n  }\n\n  .navbar-custom .navbar-nav> :not([hidden])~ :not([hidden]) {\n    --tw-space-x-reverse: 0;\n    margin-right: calc(1rem * var(--tw-space-x-reverse));\n    /* margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse))); */\n  }\n\n  .navbar-custom .navbar-nav {\n    font-size: 15px;\n  }\n}\n\n.navbar-custom .navbar-nav .nav-item {\n  display: flex;\n  --tw-border-opacity: 1;\n  border-color: rgb(243 244 246 / var(--tw-border-opacity));\n  padding: 0.75rem;\n  color: rgba(255, 255, 255, 255);\n  align-items: center;\n}\n\n.navbar-custom .navbar-nav .nav-item:hover {\n  --tw-text-opacity: 1;\n  color: rgb(255 255 255 255);\n}\n\n@media (min-width: 992px) {\n  .navbar-custom .navbar-nav .nav-item {\n    border-width: 0px;\n  }\n\n  .navbar-custom .navbar-nav .nav-item:hover {\n    background-color: transparent;\n  }\n}\n\n@media (min-width: 1200px) {\n  .navbar-custom .navbar-nav .nav-item {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n}\n\n\n\n \n  \n\n@media (min-width: 992px) {\n  .lg\\:container {\n    width: 100%;\n    margin-right: auto;\n    margin-left: auto;\n    padding-right: 1rem;\n    padding-left: 1rem;\n  }\n\n  @media (min-width: 576px) {\n    .lg\\:container {\n      max-width: 576px;\n      padding-right: 2rem;\n      padding-left: 2rem;\n    }\n  }\n\n  @media (min-width: 768px) {\n    .lg\\:container {\n      max-width: 768px;\n    }\n  }\n\n  @media (min-width: 992px) {\n    .lg\\:container {\n      max-width: 992px;\n      padding-right: 4rem;\n      padding-left: 4rem;\n    }\n  }\n\n  @media (min-width: 1200px) {\n    .lg\\:container {\n      max-width: 1200px;\n      padding-right: 5rem;\n      padding-left: 5rem;\n    }\n  }\n\n  @media (min-width: 1400px) {\n    .lg\\:container {\n      max-width: 1400px;\n      padding-right: 9rem;\n      padding-left: 9rem;\n    }\n  }\n}\n\n.marker\\:text-lg *::marker {\n  font-size: 1.125rem !important;\n  line-height: 1.75rem !important;\n}\n\n.marker\\:text-blue-500 *::marker {\n  color: rgb(59 130 246) !important;\n}\n\n.marker\\:text-cyan-500 *::marker {\n  color: rgb(6 182 212) !important;\n}\n\n.marker\\:text-green-500 *::marker {\n  color: rgb(34 197 94) !important;\n}\n\n.marker\\:text-purple-500 *::marker {\n  color: rgb(168 85 247) !important;\n}\n\n.marker\\:text-red-500 *::marker {\n  color: rgb(239 68 68) !important;\n}\n\n.marker\\:text-yellow-500 *::marker {\n  color: rgb(234 179 8) !important;\n}\n\n.marker\\:text-lg::marker {\n  font-size: 1.125rem !important;\n  line-height: 1.75rem !important;\n}\n\n.marker\\:text-blue-500::marker {\n  color: rgb(59 130 246) !important;\n}\n\n.marker\\:text-cyan-500::marker {\n  color: rgb(6 182 212) !important;\n}\n\n.marker\\:text-green-500::marker {\n  color: rgb(34 197 94) !important;\n}\n\n.marker\\:text-purple-500::marker {\n  color: rgb(168 85 247) !important;\n}\n\n.marker\\:text-red-500::marker {\n  color: rgb(239 68 68) !important;\n}\n\n.marker\\:text-yellow-500::marker {\n  color: rgb(234 179 8) !important;\n}\n\n.placeholder\\:text-sm::-webkit-input-placeholder {\n  font-size: 0.875rem !important;\n  line-height: 1.25rem !important;\n}\n\n.placeholder\\:text-sm::-moz-placeholder {\n  font-size: 0.875rem !important;\n  line-height: 1.25rem !important;\n}\n\n.placeholder\\:text-sm:-ms-input-placeholder {\n  font-size: 0.875rem !important;\n  line-height: 1.25rem !important;\n}\n\n.placeholder\\:text-sm::-ms-input-placeholder {\n  font-size: 0.875rem !important;\n  line-height: 1.25rem !important;\n}\n\n.placeholder\\:text-sm::placeholder {\n  font-size: 0.875rem !important;\n  line-height: 1.25rem !important;\n}\n\n.before\\:absolute::before {\n  content: var(--tw-content) !important;\n  position: absolute !important;\n}\n\n.before\\:left-\\[19px\\]::before {\n  content: var(--tw-content) !important;\n  left: 19px !important;\n}\n\n.before\\:top-11::before {\n  content: var(--tw-content) !important;\n  top: 2.75rem !important;\n}\n\n.before\\:top-\\[50px\\]::before {\n  content: var(--tw-content) !important;\n  top: 50px !important;\n}\n\n.before\\:hidden::before {\n  content: var(--tw-content) !important;\n  display: none !important;\n}\n\n.before\\:h-24::before {\n  content: var(--tw-content) !important;\n  height: 6rem !important;\n}\n\n.before\\:w-2\\/3::before {\n  content: var(--tw-content) !important;\n  width: 66.666667% !important;\n}\n\n.before\\:border::before {\n  content: var(--tw-content) !important;\n  border-width: 1px !important;\n}\n\n.before\\:border-dashed::before {\n  content: var(--tw-content) !important;\n  border-style: dashed !important;\n}\n\n.before\\:border-gray-300::before {\n  content: var(--tw-content) !important;\n  --tw-border-opacity: 1 !important;\n  border-color: rgb(209 213 219 / var(--tw-border-opacity)) !important;\n}\n\n.before\\:border-red-500\\/40::before {\n  content: var(--tw-content) !important;\n  border-color: rgb(239 68 68 / 0.4) !important;\n}\n\n.before\\:content-\\[\\'\\'\\]::before {\n  --tw-content: '' !important;\n  content: var(--tw-content) !important;\n}\n\n.checked\\:bg-red-500:checked {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(239 68 68 / var(--tw-bg-opacity)) !important;\n}\n\n.checked\\:ring-0:checked {\n  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;\n  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;\n  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;\n}\n\n.checked\\:ring-offset-0:checked {\n  --tw-ring-offset-width: 0px !important;\n}\n\n.hover\\:-translate-y-1:hover {\n  --tw-translate-y: -0.25rem !important;\n  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;\n}\n\n.hover\\:-translate-y-2:hover {\n  --tw-translate-y: -0.5rem !important;\n  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;\n}\n\n.hover\\:-translate-y-4:hover {\n  --tw-translate-y: -1rem !important;\n  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;\n}\n\n.hover\\:bg-blue-700:hover {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(29 78 216 / var(--tw-bg-opacity)) !important;\n}\n\n.hover\\:bg-green-500:hover {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(34 197 94 / var(--tw-bg-opacity)) !important;\n}\n\n.hover\\:bg-red-500:hover {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(239 68 68 / var(--tw-bg-opacity)) !important;\n}\n\n.hover\\:bg-yellow-500:hover {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(234 179 8 / var(--tw-bg-opacity)) !important;\n}\n\n.hover\\:text-black:hover {\n  --tw-text-opacity: 1 !important;\n  color: rgb(0 0 0 / var(--tw-text-opacity)) !important;\n}\n\n.hover\\:text-blue-500:hover {\n  --tw-text-opacity: 1 !important;\n  color: rgb(59 130 246 / var(--tw-text-opacity)) !important;\n}\n\n.hover\\:text-cyan-500:hover {\n  --tw-text-opacity: 1 !important;\n  color: rgb(6 182 212 / var(--tw-text-opacity)) !important;\n}\n\n.hover\\:text-gray-300:hover {\n  --tw-text-opacity: 1 !important;\n  color: rgb(209 213 219 / var(--tw-text-opacity)) !important;\n}\n\n.hover\\:text-green-500:hover {\n  --tw-text-opacity: 1 !important;\n  color: rgb(34 197 94 / var(--tw-text-opacity)) !important;\n}\n\n.hover\\:text-purple-500:hover {\n  --tw-text-opacity: 1 !important;\n  color: rgb(168 85 247 / var(--tw-text-opacity)) !important;\n}\n\n.hover\\:text-red-500:hover {\n  --tw-text-opacity: 1 !important;\n  color: rgb(239 68 68 / var(--tw-text-opacity)) !important;\n}\n\n.hover\\:text-white:hover {\n  --tw-text-opacity: 1 !important;\n  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;\n}\n\n.hover\\:text-yellow-500:hover {\n  --tw-text-opacity: 1 !important;\n  color: rgb(234 179 8 / var(--tw-text-opacity)) !important;\n}\n\n.focus\\:border-0:focus {\n  border-width: 0px !important;\n}\n\n.focus\\:border-gray-400:focus {\n  --tw-border-opacity: 1 !important;\n  border-color: rgb(156 163 175 / var(--tw-border-opacity)) !important;\n}\n\n.focus\\:border-red-300:focus {\n  --tw-border-opacity: 1 !important;\n  border-color: rgb(252 165 165 / var(--tw-border-opacity)) !important;\n}\n\n.focus\\:text-black:focus {\n  --tw-text-opacity: 1 !important;\n  color: rgb(0 0 0 / var(--tw-text-opacity)) !important;\n}\n\n.focus\\:outline-none:focus {\n  outline: 2px solid transparent !important;\n  outline-offset: 2px !important;\n}\n\n.focus\\:ring:focus {\n  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;\n  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;\n  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;\n}\n\n.focus\\:ring-0:focus {\n  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;\n  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;\n  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;\n}\n\n.focus\\:ring-red-200:focus {\n  --tw-ring-opacity: 1 !important;\n  --tw-ring-color: rgb(254 202 202 / var(--tw-ring-opacity)) !important;\n}\n\n.focus\\:ring-opacity-50:focus {\n  --tw-ring-opacity: 0.5 !important;\n}\n\n.focus\\:ring-offset-0:focus {\n  --tw-ring-offset-width: 0px !important;\n}\n\n.group:hover .group-hover\\:bg-blue-500 {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(59 130 246 / var(--tw-bg-opacity)) !important;\n}\n\n.group:hover .group-hover\\:bg-cyan-500 {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(6 182 212 / var(--tw-bg-opacity)) !important;\n}\n\n.group:hover .group-hover\\:bg-green-500 {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(34 197 94 / var(--tw-bg-opacity)) !important;\n}\n\n.group:hover .group-hover\\:bg-purple-500 {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(168 85 247 / var(--tw-bg-opacity)) !important;\n}\n\n.group:hover .group-hover\\:bg-red-500 {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(239 68 68 / var(--tw-bg-opacity)) !important;\n}\n\n.group:hover .group-hover\\:bg-yellow-500 {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(234 179 8 / var(--tw-bg-opacity)) !important;\n}\n\n.group:hover .group-hover\\:text-white {\n  --tw-text-opacity: 1 !important;\n  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;\n}\n\n[dir=\"ltr\"] .ltr\\:left-0 {\n  left: 0px !important;\n}\n\n[dir=\"ltr\"] .ltr\\:left-40 {\n  left: 10rem !important;\n}\n\n[dir=\"ltr\"] .ltr\\:right-40 {\n  right: 10rem !important;\n}\n\n[dir=\"ltr\"] .ltr\\:ml-0 {\n  margin-left: 0px !important;\n}\n\n[dir=\"ltr\"] .ltr\\:ml-2 {\n  margin-left: 0.5rem !important;\n}\n\n[dir=\"ltr\"] .ltr\\:ml-auto {\n  margin-left: auto !important;\n}\n\n[dir=\"ltr\"] .ltr\\:mr-2 {\n  margin-right: 0.5rem !important;\n}\n\n[dir=\"ltr\"] .ltr\\:hidden {\n  display: none !important;\n}\n\n[dir=\"ltr\"] .ltr\\:rotate-0 {\n  --tw-rotate: 0deg !important;\n  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;\n}\n\n[dir=\"ltr\"] .ltr\\:rounded-r {\n  border-top-right-radius: 0.25rem !important;\n  border-bottom-right-radius: 0.25rem !important;\n}\n\n[dir=\"ltr\"] .ltr\\:before\\:-right-32::before {\n  content: var(--tw-content) !important;\n  right: -8rem !important;\n}\n\n[dir=\"rtl\"] .rtl\\:left-40 {\n  left: 10rem !important;\n}\n\n[dir=\"rtl\"] .rtl\\:right-0 {\n  right: 0px !important;\n}\n\n[dir=\"rtl\"] .rtl\\:right-40 {\n  right: 10rem !important;\n}\n\n[dir=\"rtl\"] .rtl\\:ml-2 {\n  margin-left: 0.5rem !important;\n}\n\n[dir=\"rtl\"] .rtl\\:mr-0 {\n  margin-right: 0px !important;\n}\n\n[dir=\"rtl\"] .rtl\\:mr-2 {\n  margin-right: 0.5rem !important;\n}\n\n[dir=\"rtl\"] .rtl\\:mr-auto {\n  margin-right: auto !important;\n}\n\n[dir=\"rtl\"] .rtl\\:hidden {\n  display: none !important;\n}\n\n[dir=\"rtl\"] .rtl\\:rotate-180 {\n  --tw-rotate: 180deg !important;\n  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;\n}\n\n[dir=\"rtl\"] .rtl\\:rounded-l {\n  border-top-left-radius: 0.25rem !important;\n  border-bottom-left-radius: 0.25rem !important;\n}\n\n[dir=\"rtl\"] .rtl\\:before\\:-left-32::before {\n  content: var(--tw-content) !important;\n  left: -8rem !important;\n}\n\n[data-mode=\"dark\"] .dark\\:block {\n  display: block !important;\n}\n\n[data-mode=\"dark\"] .dark\\:hidden {\n  display: none !important;\n}\n\n[data-mode=\"dark\"] .dark\\:border-transparent {\n  border-color: transparent !important;\n}\n\n[data-mode=\"dark\"] .dark\\:border-zinc-700\\/30 {\n  border-color: rgb(63 63 70 / 0.3) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:border-zinc-700\\/50 {\n  border-color: rgb(63 63 70 / 0.5) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:border-zinc-700\\/80 {\n  border-color: rgb(63 63 70 / 0.8) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:bg-white {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:bg-zinc-700 {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(63 63 70 / var(--tw-bg-opacity)) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:bg-zinc-700\\/20 {\n  background-color: rgb(63 63 70 / 0.2) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:bg-zinc-700\\/30 {\n  background-color: rgb(63 63 70 / 0.3) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:bg-zinc-800 {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(39 39 42 / var(--tw-bg-opacity)) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:bg-zinc-900\\/20 {\n  background-color: rgb(24 24 27 / 0.2) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:bg-zinc-900\\/30 {\n  background-color: rgb(24 24 27 / 0.3) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:bg-zinc-900\\/40 {\n  background-color: rgb(24 24 27 / 0.4) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:bg-zinc-900\\/50 {\n  background-color: rgb(24 24 27 / 0.5) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:bg-zinc-900\\/60 {\n  background-color: rgb(24 24 27 / 0.6) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:text-gray-300 {\n  --tw-text-opacity: 1 !important;\n  color: rgb(209 213 219 / var(--tw-text-opacity)) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:text-gray-300\\/50 {\n  color: rgb(209 213 219 / 0.5) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:text-gray-300\\/60 {\n  color: rgb(209 213 219 / 0.6) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:text-gray-300\\/80 {\n  color: rgb(209 213 219 / 0.8) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:text-white {\n  --tw-text-opacity: 1 !important;\n  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:text-white\\/60 {\n  color: rgb(255 255 255 / 0.6) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:text-white\\/80 {\n  color: rgb(255 255 255 / 0.8) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:text-zinc-800 {\n  --tw-text-opacity: 1 !important;\n  color: rgb(39 39 42 / var(--tw-text-opacity)) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:placeholder\\:text-gray-300\\/50::-webkit-input-placeholder {\n  color: rgb(209 213 219 / 0.5) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:placeholder\\:text-gray-300\\/50::-moz-placeholder {\n  color: rgb(209 213 219 / 0.5) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:placeholder\\:text-gray-300\\/50:-ms-input-placeholder {\n  color: rgb(209 213 219 / 0.5) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:placeholder\\:text-gray-300\\/50::-ms-input-placeholder {\n  color: rgb(209 213 219 / 0.5) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:placeholder\\:text-gray-300\\/50::placeholder {\n  color: rgb(209 213 219 / 0.5) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:placeholder\\:text-gray-300\\/60::-webkit-input-placeholder {\n  color: rgb(209 213 219 / 0.6) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:placeholder\\:text-gray-300\\/60::-moz-placeholder {\n  color: rgb(209 213 219 / 0.6) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:placeholder\\:text-gray-300\\/60:-ms-input-placeholder {\n  color: rgb(209 213 219 / 0.6) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:placeholder\\:text-gray-300\\/60::-ms-input-placeholder {\n  color: rgb(209 213 219 / 0.6) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:placeholder\\:text-gray-300\\/60::placeholder {\n  color: rgb(209 213 219 / 0.6) !important;\n}\n\n[data-mode=\"dark\"] .before\\:dark\\:border-zinc-700\\/50::before {\n  content: var(--tw-content) !important;\n  border-color: rgb(63 63 70 / 0.5) !important;\n}\n\n[data-mode=\"dark\"] .dark\\:checked\\:bg-red-500:checked {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(239 68 68 / var(--tw-bg-opacity)) !important;\n}\n\n@media (min-width: 768px) {\n  .md\\:mx-auto {\n    margin-left: auto !important;\n    margin-right: auto !important;\n  }\n\n  .md\\:flex {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n  }\n\n  .md\\:grid-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n  }\n\n  .md\\:grid-cols-4 {\n    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;\n  }\n\n  .md\\:flex-row {\n    -webkit-box-orient: horizontal !important;\n    -webkit-box-direction: normal !important;\n    -ms-flex-direction: row !important;\n    flex-direction: row !important;\n  }\n\n  .md\\:justify-between {\n    -webkit-box-pack: justify !important;\n    -ms-flex-pack: justify !important;\n    justify-content: space-between !important;\n  }\n\n  .md\\:text-\\[32px\\] {\n    font-size: 32px !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .lg\\:absolute {\n    position: absolute !important;\n  }\n\n  .lg\\:order-1 {\n    -webkit-box-ordinal-group: 2 !important;\n    -ms-flex-order: 1 !important;\n    order: 1 !important;\n  }\n\n  .lg\\:order-2 {\n    -webkit-box-ordinal-group: 3 !important;\n    -ms-flex-order: 2 !important;\n    order: 2 !important;\n  }\n\n  .lg\\:col-span-2 {\n    grid-column: span 2 / span 2 !important;\n  }\n\n  .lg\\:col-span-3 {\n    grid-column: span 3 / span 3 !important;\n  }\n\n  .lg\\:col-span-5 {\n    grid-column: span 5 / span 5 !important;\n  }\n\n  .lg\\:col-span-7 {\n    grid-column: span 7 / span 7 !important;\n  }\n\n  .lg\\:mx-10 {\n    margin-left: 2.5rem !important;\n    margin-right: 2.5rem !important;\n  }\n\n  .lg\\:ml-0 {\n    margin-left: 0px !important;\n  }\n\n  .lg\\:ml-14 {\n    margin-left: 3.5rem !important;\n  }\n\n  .lg\\:ml-auto {\n    margin-left: auto !important;\n  }\n\n  .lg\\:mr-0 {\n    margin-right: 0px !important;\n  }\n\n  .lg\\:mt-0 {\n    margin-top: 0px !important;\n  }\n\n  .lg\\:mt-10 {\n    margin-top: 2.5rem !important;\n  }\n\n  .lg\\:block {\n    display: block !important;\n  }\n\n  .lg\\:flex {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n  }\n\n  .lg\\:grid {\n    display: grid !important;\n  }\n\n  .lg\\:hidden {\n    display: none !important;\n  }\n\n  .lg\\:h-auto {\n    height: auto !important;\n  }\n\n  .lg\\:w-2\\/3 {\n    width: 66.666667% !important;\n  }\n\n  .lg\\:w-5\\/12 {\n    width: 41.666667% !important;\n  }\n\n  .lg\\:w-7\\/12 {\n    width: 58.333333% !important;\n  }\n\n  .lg\\:w-auto {\n    width: auto !important;\n  }\n\n  .lg\\:grid-cols-12 {\n    grid-template-columns: repeat(12, minmax(0, 1fr)) !important;\n  }\n\n  .lg\\:grid-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n  }\n\n  .lg\\:grid-cols-3 {\n    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;\n  }\n\n  .lg\\:grid-cols-4 {\n    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;\n  }\n\n  .lg\\:flex-row {\n    -webkit-box-orient: horizontal !important;\n    -webkit-box-direction: normal !important;\n    -ms-flex-direction: row !important;\n    flex-direction: row !important;\n  }\n\n  .lg\\:flex-col {\n    -webkit-box-orient: vertical !important;\n    -webkit-box-direction: normal !important;\n    -ms-flex-direction: column !important;\n    flex-direction: column !important;\n  }\n\n  .lg\\:justify-start {\n    -webkit-box-pack: start !important;\n    -ms-flex-pack: start !important;\n    justify-content: flex-start !important;\n  }\n\n  .lg\\:space-x-4> :not([hidden])~ :not([hidden]) {\n    --tw-space-x-reverse: 0 !important;\n    margin-right: calc(1rem * var(--tw-space-x-reverse)) !important;\n    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse))) !important;\n  }\n\n  .lg\\:overflow-visible {\n    overflow: visible !important;\n  }\n\n  .lg\\:border-0 {\n    border-width: 0px !important;\n  }\n\n  .lg\\:bg-white {\n    --tw-bg-opacity: 1 !important;\n    background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;\n  }\n\n  .lg\\:py-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n\n  .lg\\:py-3 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n\n  .lg\\:py-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n\n  .lg\\:pb-32 {\n    padding-bottom: 8rem !important;\n  }\n\n  .lg\\:pb-40 {\n    padding-bottom: 10rem !important;\n  }\n\n  .lg\\:pr-10 {\n    padding-right: 2.5rem !important;\n  }\n\n  .lg\\:pr-\\[17px\\] {\n    padding-right: 17px !important;\n  }\n\n  .lg\\:pt-56 {\n    padding-top: 14rem !important;\n  }\n\n  .lg\\:text-left {\n    text-align: left !important;\n  }\n\n  .lg\\:text-center {\n    text-align: center !important;\n  }\n\n  .lg\\:text-\\[15px\\] {\n    font-size: 15px !important;\n  }\n\n  .lg\\:text-\\[46px\\] {\n    font-size: 46px !important;\n  }\n\n  .lg\\:text-gray-500 {\n    --tw-text-opacity: 1 !important;\n    color: rgb(107 114 128 / var(--tw-text-opacity)) !important;\n  }\n\n  .lg\\:shadow-lg {\n    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1) !important;\n    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color) !important;\n    -webkit-box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;\n    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;\n  }\n\n  .before\\:lg\\:block::before {\n    content: var(--tw-content) !important;\n    display: block !important;\n  }\n\n  .lg\\:hover\\:bg-gray-100:hover {\n    --tw-bg-opacity: 1 !important;\n    background-color: rgb(243 244 246 / var(--tw-bg-opacity)) !important;\n  }\n\n  .lg\\:hover\\:bg-transparent:hover {\n    background-color: transparent !important;\n  }\n\n  [dir=\"ltr\"] .ltr\\:lg\\:ml-14 {\n    margin-left: 3.5rem !important;\n  }\n\n  [dir=\"ltr\"] .ltr\\:lg\\:ml-auto {\n    margin-left: auto !important;\n  }\n\n  [dir=\"ltr\"] .ltr\\:lg\\:text-right {\n    text-align: right !important;\n  }\n\n  [dir=\"rtl\"] .rtl\\:lg\\:mr-14 {\n    margin-right: 3.5rem !important;\n  }\n\n  [dir=\"rtl\"] .rtl\\:lg\\:mr-auto {\n    margin-right: auto !important;\n  }\n\n  [dir=\"rtl\"] .rtl\\:lg\\:text-left {\n    text-align: left !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .xl\\:grid-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n  }\n\n  .xl\\:bg-transparent {\n    background-color: transparent !important;\n  }\n\n  [data-mode=\"dark\"] .dark\\:xl\\:bg-transparent {\n    background-color: transparent !important;\n  }\n}\n\n/* @media (max-width: 1250px) {\n  .Heading-02 {\n    font-size: 45px;\n  }\n} */\n\n@media (max-width: 1190px) {\n  \n\n  .elementor-motion-effects-layer2 {\n    background-position: 481% -328px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .react-multiple-carousel__arrow {\n    display: none;\n  }\n\n  /* li.react-multi-carousel-item {\n    margin-right: 15px;\n  } */\n}\n\n/* responsive */\n\n@media (max-width: 1191px) {\n\n  .Heading-01 {\n    font-size: 50px;\n  }\n\n  .heading-para {\n    font-size: 12px;\n  }\n\n  .bbt {\n    border-radius: 6px;\n    height: 49px;\n  }\n}\n\n@media (max-width: 1042px) {\n\n  .Heading-01 {\n    font-size: 40px;\n  }\n\n  .heading-para {\n    font-size: 12px;\n  }\n\n}\n\n@media (max-width: 992px) {\n  .heading-para {\n    display: none;\n  }\n\n  .Heading-01 {\n    font-size: 33px;\n  }\n\n  .dropdown-menu {\n    position: absolute;\n    --tw-bg-opacity: 1;\n    background-color: rgb(255 255 255 / var(--tw-bg-opacity));\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);\n    -webkit-box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n  }\n}\n\n@media (max-width: 767px){\n  /* .available-app-area{\n    padding-top: 50px;\n    padding-bottom: 50px;\n  } */\n  .section-tittle h2{\n    font-size: 35px;\n  }\n  \n}\n\n@media (max-width:597px) {\n  .Heading-01 {\n    font-size: 25px;\n  }\n\n  .slider {\n    padding: 0;\n    margin: 0 10px !important;\n  }\n  .section-tittle h2 {\n    font-size: 26px;\n}\n.Heading-02 {\n  font-size: 38px;\n}\n.paragraph {\n  font-size: 16px;\n  color: #737e8c;\n}\n.elementor-icon-list-text{\n  font-size: 16px;\n}\n.Secure {\n  position: relative;\n  top: 2px;\n  height: 91px;\n}\n.simple {\n  position: relative;\n  top: -4px;\n  height: 65px;\n}\n.Reliable {\n  position: relative;\n  top: 4px;\n  height: 64px !important;\n}\n}\n\n@media (max-width:480px) {\n  .Heading-01 {\n    font-size: 20px;\n  }\n}\n\n.carousel-item-padding-40-px {\n  height: 100%;\n  align-items: center;\n  display: flex;\n}\n/* .react-multi-carousel-track{\n  gap: 15px;\n} */\n\n/* @media (max-width: 480px){\n  li.react-multi-carousel-item{\n    width: 155px !important;\n  }\n} */\n\n\n.radio-button-label > input { \n\tdisplay: none;\n}\n.radio-button-label > img {\n\tcursor: pointer;\n\t/* border: 3px solid #ddd; */\n\t/* width: 100px; */\n}\n\n.radio-button-label > input:checked + img {\n  border: 3px solid #efcfb2 !important;\n  background: #fff;\n  padding: 2px;\n  box-shadow: 2px 8px 8px 2px #c1c1c194;\n  border-radius: 7px;\n \n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
